import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_TRACKERS_PERMISSIONS } from '@modules/affiliate-trackers/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type {
  IAffiliateProgramCreativeLinkResponse,
} from '../types';
import {
  AFFILIATE_TRACKERS_CREATIVES_LINK_QUERY_KEY,
  AFFILIATE_TRACKERS_CREATIVES_LINK_URL,
} from '../constants';

export default function useAffiliateTrackersCreativeLinkQuery(
  creative_id: Ref<number>,
  serial: Ref<number | undefined>,
  anid: Ref<string>,
  isEnabled: Ref<boolean>,
): IContextQueryResult<IAffiliateProgramCreativeLinkResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateProgramCreativeLinkResponse>({
    queryKey: [AFFILIATE_TRACKERS_CREATIVES_LINK_QUERY_KEY, creative_id, serial, anid],
    queryFn: ({ signal }) => fetchGet<IAffiliateProgramCreativeLinkResponse>(
      AFFILIATE_TRACKERS_CREATIVES_LINK_URL,
      {
        signal,
        permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW_CREATIVE,
        queryParams: {
          creative_id: creative_id.value,
          serial: serial.value,
          anid: anid.value,
        },
      },
    ),
    staleTime: 5000,
    placeholderData: keepPreviousData,
    enabled: computed(() => isEnabled.value && !!serial.value && !!creative_id.value),
  });
}
